import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Controller } from 'react-hook-form';
import { classNames } from 'primereact/utils';

// Helper function to convert dateFormat to mask
// PrimeReact dateFormat: d=day, dd=2-digit day, m=month, mm=2-digit month, 
// y=2-digit year, yy=4-digit year
const getMaskForDateFormat = (dateFormat, showTime) => {
  if (!dateFormat) return showTime ? '99/99/9999 99:99' : '99/99/9999';
  
  // Build mask by replacing format tokens with mask characters
  // Order matters: replace longer tokens first
  let mask = dateFormat
    .replace(/dd/g, '99')   // 2-digit day
    .replace(/d/g, '9')     // single digit day (rare)
    .replace(/mm/g, '99')   // 2-digit month
    .replace(/m/g, '9')     // single digit month (rare)
    .replace(/yy/g, '9999') // 4-digit year (in PrimeReact, 'yy' = 4 digits)
    .replace(/y/g, '99');   // 2-digit year
  
  if (showTime) {
    mask += ' 99:99';
  }
  
  return mask;
};

const EzControlledCalendarWithFloatingLabel = (props) => {
  const {
    control,
    dateFormat = 'mm/dd/yy',
    name,
    rules,
    labelClassName = '',
    label,
    minDate,
    maxDate = new Date(),
    errorMsg,
    isError,
    showIcon = true,
    showButtonBar = false,
    showTime = false,
    showSeconds = false,
    timeOnly = false,
    hideOnDateTimeSelect = false,
    hourFormat = '12',
    onDateChange,
    appendTo,
    panelClassName,
    panelStyle,
    autoZIndex,
    baseZIndex,
    disabled = false,
  } = props;

  const getLabelClassName = () => {
    return classNames({
      'p-error': isError,
      labelClassName,
    });
  };

  // Generate mask based on dateFormat
  const mask = getMaskForDateFormat(dateFormat, showTime);

  return (
    <div className="field">
      <span className="p-float-label">
        <Controller
          name={name}
          rules={rules}
          control={control}
          render={({ field }) => {
            return (
              <Calendar
                {...field}
                disabled={disabled}
                minDate={minDate}
                maxDate={maxDate}
                timeOnly={timeOnly}
                hideOnDateTimeSelect={hideOnDateTimeSelect}
                hourFormat={hourFormat}
                showTime={showTime}
                showSeconds={showSeconds}
                id={field.name}
                value={field.value ? new Date(field.value) : null}
                onChange={(e) => {
                  if (onDateChange) {
                    onDateChange(e);
                  }
                  if(e.value !== null) {
                    field.onChange(e.value);
                  }
                }}
                dateFormat={dateFormat}
                mask={mask}
                showIcon={showIcon}
                showButtonBar={showButtonBar}
                showOnFocus={false}
                selectOtherMonths={true}
                appendTo={appendTo}
                panelClassName={panelClassName}
                panelStyle={panelStyle}
                autoZIndex={autoZIndex}
                baseZIndex={baseZIndex}
              />
            );
          }}
        />

        <label htmlFor={name} className={getLabelClassName()}>
          {rules?.required ? `${label}*` : label}
        </label>
      </span>
      {errorMsg}
    </div>
  );
};

export default EzControlledCalendarWithFloatingLabel;
